// extracted by mini-css-extract-plugin
module.exports = {"withSortable":"LocationsTable_withSortable__v8c_v"};